const STATS_RESET_TIMER = 10000

export class FpsMeter {
  private frameCount = 0
  private lastTime = performance.now()
  private statsTimer = performance.now()
  private running = false

  // stats
  private avgFps: number | null = null
  private minFps = Infinity
  private maxFps = -Infinity

  constructor(private el: HTMLElement) {
    this.update = this.update.bind(this)
  }

  public start() {
    this.reset()

    this.running = true
    this.el.style.display = 'block'

    this.update()
  }

  public stop() {
    this.reset()
  }

  private reset() {
    this.el.style.display = 'hidden'

    this.avgFps = null
    this.frameCount = 0
    this.lastTime = performance.now()
    this.maxFps = -Infinity
    this.minFps = Infinity
    this.running = false
    this.statsTimer = performance.now()
  }

  private update() {
    if (!this.running) {
      return
    }

    this.frameCount++
    const currentTime = performance.now()
    const elapsedTime = currentTime - this.lastTime

    const elapsedReset = currentTime - this.statsTimer
    if (elapsedReset >= STATS_RESET_TIMER) {
      this.maxFps = -Infinity
      this.minFps = Infinity
      this.avgFps = null

      this.statsTimer = currentTime
    }

    if (elapsedTime >= 1000) {
      const fps = (this.frameCount * 1000) / elapsedTime
      this.maxFps = Math.max(this.maxFps, fps)
      this.minFps = Math.min(this.minFps, fps)

      if (this.avgFps === null) {
        this.avgFps = fps
      } else {
        this.avgFps = (this.avgFps + fps) / 2
      }

      this.el.innerHTML = `
<div style="color: ${getTextColor(fps)}">FPS: ${fps.toFixed(2)}</div>
<div>Min: ${this.minFps.toFixed(2)}</div>
<div>Max: ${this.maxFps.toFixed(2)}</div>
<div>Avg: ${this.avgFps.toFixed(2)}</div>
<div>Rst: ${Math.ceil(elapsedReset / 1000).toFixed(2)}</div>
`

      this.frameCount = 0
      this.lastTime = currentTime
    }

    requestAnimationFrame(this.update)
  }
}

function getTextColor(fps: number): string {
  switch (true) {
    case fps >= 30:
      return 'green'
    case fps >= 20:
      return 'yellow'
    default:
      return 'red'
  }
}
